import { toast } from '@/components/toast';
import { GET_SUBSCRIPTION_KEY } from '@/pages/account-settings/components/Billing';
import { cancelSubscription as _cancelSubscription } from '@/services/api';
import { logger } from '@/services/logger';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

interface Props {
    setOpen: (state: boolean) => void;
    setIsLoadingOpen: (state: boolean) => void;
    setIsCancelationOpen?: (state: boolean) => void;
}

export const useCancelSubscription = ({ setOpen, setIsLoadingOpen, setIsCancelationOpen }: Props) => {
    const queryClient = useQueryClient();
    const { mutateAsync: cancelSubscription, isLoading: isCanceling } = useMutation('cancel-subscription', _cancelSubscription, {
        onError: error => {
            if ((error as AxiosError<any>)?.response?.data?.kind === 'PlanChangeSupportNeededError') {
                toast.error({ title: "Let's talk. Please contact support to cancel your subscription" });
            } else {
                logger.error('Failed to cancel subscription', error);
                toast.error({ title: 'Failed to cancel subscription' });
            }
            setOpen(false);
        },
        onSuccess: async () => {
            setIsLoadingOpen(false);
            setIsCancelationOpen?.(true);
            await queryClient.invalidateQueries(GET_SUBSCRIPTION_KEY);
        },
    });
    return { cancelSubscription, isCanceling };
};
